
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';



import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
const _preserve = React.version;

import { Button, SelectProps, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiRefresh } from '@mdi/js';
import { Icon } from '@mdi/react';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelFlight from '../../../../../components/extras/SidePanelFlight';
import TableFlights from '../../../../../components/tables/tableFlights';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemAltitudes, ItemFlight } from '../../../../../resources/types';
import {
    addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie,
    getUrlVersion,
    setData,
    setLoading,
    setParameters
} from '../../../../commons/functions';
import { useStore } from '../../../store';




type OptionDefinition = SelectProps.Option;

type ItemFrequent = {
    id: string;
    text: string;
};
type ItemEquipment = {
    idEquipment: number;
    registration: string;
};

export const OPSFlightsLogs = () => {
    const { data, menu, parameters } = useGlobalState();
    //const storeAdmin = useStoreAdmin();

    const [keyw, setKeyw] = useState("");
    const [altitudes, setAltitudes] = useState<ItemAltitudes[]>([]);

    const [validFlight, setValidFlight] = useState(true);
    const [costValue, setCostValue] = useState("");

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const [flight, setFlight] = useState<ItemFlight>();
    const [flights, setFlights] = useState<ItemFlight[]>([]);
    const [flightsSearch, setFlightsSearch] = useState<ItemFlight[]>([]);


    const [costOther, setCostOther] = useState("0");
    const [chargeIdUser, setChargeIdUser] = useState(-1);
    const [chargeValid, setChargeValid] = useState(true);
    const mountedRef = useRef(false);


    const [showEquipmentPicker, setShowEquipmentPicker] = useState(false);

    useEffect(() => {
        if (flight) {

        }
    }, [flight]);
    useEffect(() => {
        console.log(mountedRef.current)
        if (mountedRef.current)
            handleRefresh();
    }, [parameters.date]);


    let tmpFlight: ItemFlight



    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {
                if (!mountedRef.current) {
                    mountedRef.current = true;
                    handleRefresh();
                }
                handleGetFlight(id ? parseInt(id) : 0);
            }
            else {
                setFlight(undefined);
                handleRefresh();
                mountedRef.current = true;
            }
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);
    useEffect(() => {
        setChargeValid(false)
        if (chargeIdUser === 0) setChargeValid(true)
        if (costValue === "") setChargeValid(true)
        if (costValue === "costOther" && costOther === "") {
            setChargeValid(true)
        }
    }, [chargeIdUser, costValue, costOther]);


    useEffect(() => {
        let valid = true
        if (!(flight?.idEquipment !== undefined && flight.idEquipment > 0)) valid = false;
        if (!(flight?.idUserPilot !== undefined && flight.idUserPilot > 0)) valid = false;
        if (!(flight?.departureTime !== undefined && flight.departureTime.length == 5)) valid = false;
        if (!(flight?.arrivalTime !== undefined && flight.arrivalTime.length == 5)) valid = false;
        if ((flight && flight.altitude && flight.altitude > 0)) {
            if (!(flight?.idUserTow !== undefined && flight.idUserTow > 0)) valid = false;
            if (!(flight?.idEquipmentTow !== undefined && flight.idEquipmentTow > 0)) valid = false;
            if (!(flight?.arrivalTimeTow !== undefined && flight.arrivalTimeTow.length == 5)) valid = false;
        }
        if (altitudes && altitudes.length > 0) {
            if (flight && !flight.altitude) {
            }
        }
        if (!(flight?.idFlightType !== undefined && flight.idFlightType > 0)) valid = false;
        if (flight?.idFlightType !== undefined && flight.idFlightType > 0) {
            if (flight.idFlightType === 1133 || flight.idFlightType === 1135 || flight.idFlightType === 2799) {
                if (!(flight?.idUserInstructor !== undefined && flight.idUserInstructor > 0)) valid = false;
            }
        }
        setValidFlight(valid)
    }, [flight]);

    const handleDelete = async (f: ItemFlight) => {
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/flights/delete',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idFlight: f.idFlight }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlight(undefined)
                window.location.hash = "ops/flights/logs"
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }
    const doUpdate = async (f: ItemFlight) => {
        try {
            setLoading(true)
            let body = f;
            body.softmantto = f?.jsonSoftMantto?.id && f?.jsonSoftMantto?.id !== 0 ? true : false;
            body.departureDate = `${body.departureDate} ${body.departureTime}`;
            body.arrivalDate = `${body.arrivalDate} ${body.arrivalTime}`;
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/flights/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlight(undefined)
                window.location.hash = "ops/flights/logs"
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }

    }
    const handleGetFlight = async (id: number) => {
        try {
            setFlight(undefined)
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/flight',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ idFlight: id, horometer: 1 }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlight(data.flight)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }
    const handleRefresh = async () => {
        try {
            if (parameters && parameters.date && parameters.date !== "") {
                setFlights([])
                setFlight(undefined)
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/flights/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        startDate: parameters.date,
                        endDate: parameters.date,
                        orderBy: "departureDate",
                        order: "desc",
                        orderBy2: "idTowingTo",
                        order2: "asc"
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setFlights(data.flights)
                }
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }


    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");

    const filtered: ItemFlight[] = flights.filter((item) => {

        const normalize = (str: string | undefined | null) =>
            (str || "")
                .toString()
                .toLowerCase()
                .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
                .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
                .replace(/[^a-z0-9]/g, ""); // Removes non-alphanumeric

        const searchWords = normalize(filterValue).split(/\s+/).filter(Boolean);
        const text = normalize([item.userPilot, item.idFlight.toString(), item.userInstructor, item.flightType, item.registration].join(" "))
        return searchWords.every((word) => text.includes(normalize(word)));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);


    const [currentPageIndexSearch, setCurrentPageIndexSearch] = useState(1);
    const [filterValueSearch, setFilterValueSearch] = useState("");

    const filteredSearch: ItemFlight[] = flightsSearch.filter((item) => {
        const searchWords = filterValueSearch.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.make, item.model, item.userPilot, item.idFlight.toString(), item.userInstructor, item.flightType].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
    });
    const paginatedSearch = filteredSearch.slice((currentPageIndexSearch - 1) * parameters.pageSize, currentPageIndexSearch * parameters.pageSize);


    const cal = generate2DCalendarGrid(new Date());
    console.log(cal)



    //const colors = ["red", "green", "blue", "yellow", "gray", "purple", "violet", "lightgreen", "indigo", "pink", "cyan", "lime", "orange", "brown", "dark", "smoke", "neon", "light"]
    const colors = data.usersTypes;
    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={!!flight}
            onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = "ops/flights/logs" : null}
            splitPanel={
                <SidePanelFlight flight={flight} editFlight editTimes editUsers showDelete
                    onUpdate={(f: ItemFlight) => {
                        doUpdate(f);
                    }}
                    onDelete={(f: ItemFlight) => {
                        handleDelete(f);
                    }}
                />


            }

            contentType="form"
            breadcrumbs={
                < BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />}
                        //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                        >
                            Bitácora de vuelos
                        </Header>
                        <SpaceBetween direction="horizontal" size="xs">
                            <DPModal date={parameters.date}
                                width={120}
                                clear={true}
                                end={new Date()}
                                today
                                yesterday
                                onConfirm={(date) => {

                                    const updatedParameters = {
                                        ...parameters, // clone existing keys
                                        date: date
                                    };
                                    setParameters(updatedParameters);
                                }}

                            />
                            {parameters.date && (<Button style={{ root: btnIconForm }} onClick={() => {
                                if (window.location.hash.includes("id=")) {
                                    window.location.hash = "ops/flights/logs"
                                } else {
                                    handleRefresh();
                                }
                            }}><Icon path={mdiRefresh} size={1} /></Button>)}
                        </SpaceBetween>
                        <TableFlights excel flights={flights} onSelect={(fl: ItemFlight) => window.location.hash = `ops/flights/logs?id=${fl.idFlight}`}
                            showInvoice showObs={false} showSoftMantto footer
                        />
                        {/**
                        <Table

                            filter={filtered ? (
                                <SpaceBetween direction="horizontal" size="xs">
                                    <TextFilter
                                        filteringPlaceholder="Filtrar"
                                        filteringText={filterValue}
                                        onChange={({ detail }) => {
                                            setFilterValue(detail.filteringText);
                                            setCurrentPageIndex(1);
                                        }}
                                    />
                                    <DPModal date={parameters.date}
                                        width={120}
                                        clear={true}
                                        end={new Date()}
                                        today
                                        yesterday
                                        onConfirm={(date) => {

                                            const updatedParameters = {
                                                ...parameters, // clone existing keys
                                                date: date
                                            };
                                            setParameters(updatedParameters);
                                        }}

                                    />
                                    {parameters.date && (<Button style={{ root: btnIconForm }} onClick={() => {
                                        if (window.location.hash.includes("id=")) {
                                            window.location.hash = "ops/flights/logs"
                                        } else {
                                            handleRefresh();
                                        }
                                    }}><Icon path={mdiRefresh} size={1} /></Button>)}
                                </SpaceBetween>
                            ) : undefined}
                            pagination={

                                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                    {filtered.length > parameters.pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )}

                                    {flights.length > 0 && (

                                        <SelectPaging onSelect={(pageSize) => {
                                            setCurrentPageIndex(1);
                                            setParameters({ ...parameters, pageSize: pageSize });
                                        }} />
                                    )}
                                </SpaceBetween>
                            }

                            //onRowClick={({ detail }) => handleFlightClick(detail.item)}
                            stickyHeader
                            variant="embedded"
                            wrapLines
                            columnDefinitions={[
                                {
                                    id: "idFlight",
                                    header: "ID/Fecha",
                                    cell: item => (

                                        <FormField
                                            label={<Link variant="primary" onClick={() => {
                                                window.location.hash = `ops/flights/logs?id=${item.idFlight}`
                                            }}>
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    {item.idFlight}{item?.jsonSoftMantto?.id ?
                                                        <Icon path={mdiAlphaSBox} size={0.6} />
                                                        : null}
                                                </SpaceBetween>
                                            </Link>}
                                        >
                                            {item.departureDate}
                                        </FormField>
                                    ),
                                    width: 120
                                },
                                {
                                    id: "idEquipment",
                                    header: "Equipo",
                                    cell: item => (

                                        <FormField
                                            description={`${item.category}`}
                                            label={
                                                <>
                                                    {item.registration}{" "}
                                                    {item.isClosed === 1 && <Icon path={mdiLock} size={0.7} />}
                                                </>}
                                        />
                                    ),
                                    width: 120
                                },
                                {
                                    id: "departureDate",
                                    header: "Tipo",
                                    cell: item => (

                                        <FormField
                                            description={item.altitude && item.altitude > 0 ? `Remolque ${item.altitude}m` : ""}
                                            label={<BadgeCustom color={item.bookingTypeBadge || "grey"}>{item.flightType}</BadgeCustom>}
                                        />
                                    ),
                                    width: 160
                                },
                                {
                                    id: "departureTime",
                                    header: "TPO",
                                    cell: item => (

                                        <FormField
                                            description={`${item.departureTime}-${item.arrivalTime}`}
                                            label={minutesToHHMM(item.delta ?? 0)}
                                        />
                                    ),
                                    width: 120
                                },
                                {
                                    id: "idUser",
                                    header: "Tripulación",
                                    cell: item => (

                                        <FormField
                                            description={item.idUserInstructor && item.idUserInstructor > 0 ?
                                                item.userInstructor :
                                                null
                                            }
                                            label={item.userPilot}
                                        />
                                    )
                                },
                                {
                                    id: "idUser2",
                                    header: "Facturación",
                                    width: 140,
                                    cell: item => (
                                        <>
                                            {item.isInvoiced === 0 && item.isInvoice === 1 && (
                                                <Badge color='blue'>Por Facturar</Badge>
                                            )}
                                            {item.isInvoiced === 1 && item.isInvoice === 1 && (
                                                <FormField
                                                    description={item.cost && item.cost > 0 ? `MOV #${item.idMovement}` : null}
                                                    label={item.cost && item.cost > 0 ?
                                                        new Intl.NumberFormat('es-CL', {
                                                            style: 'currency',
                                                            currency: 'CLP',
                                                            minimumFractionDigits: 0,
                                                            maximumFractionDigits: 0,
                                                        }).format(item.cost && item.cost)
                                                        : null}
                                                />
                                            )}
                                        </>
                                    )
                                },
                            ]}
                            trackBy="idFlight"
                            items={paginated ?? []}
                            empty={
                                <Box
                                    margin={{ vertical: "xs" }}
                                    textAlign="center"
                                    color="inherit"
                                >
                                    <SpaceBetween size="m">
                                        <b>Sin vuelos en fecha seleccionada</b>
                                    </SpaceBetween>
                                </Box>
                            }
                        />
                         */}
                    </SpaceBetween>




                </>
            }
        />
    );
};

export interface CalendarDay {
    date: Date;
    dateString: string; // "YYYY-MM-DD"
    dayOfMonth: number;
    dayOfWeek: number;  // 0 = Monday, 1 = Tuesday, ..., 6 = Sunday
    isCurrentMonth: boolean;
    isPrevMonth: boolean;
    isNextMonth: boolean;
}
export function generate2DCalendarGrid(inputDate: Date): CalendarDay[][] {
    const year = inputDate.getFullYear();
    const month = inputDate.getMonth();

    // First day & last day of target month
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    // Convert JS day of week (0 = Sun, 1 = Mon, ..., 6 = Sat) 
    // to Monday-based index (0 = Mon, 1 = Tue, ..., 6 = Sun)
    const leadingDays = (firstDayOfMonth.getDay() + 6) % 7;
    const trailingDays = (7 - ((lastDayOfMonth.getDay() + 6) % 7) - 1) % 7;

    // Grid start date (going back by leadingDays from the 1st)
    const startDate = new Date(year, month, 1 - leadingDays);
    const totalDays = leadingDays + lastDayOfMonth.getDate() + trailingDays;

    const weeks: CalendarDay[][] = [];
    let currentWeek: CalendarDay[] = [];

    for (let i = 0; i < totalDays; i++) {
        const currentDate = new Date(
            startDate.getFullYear(),
            startDate.getMonth(),
            startDate.getDate() + i
        );

        const currentMonth = currentDate.getMonth();

        const dayObj: CalendarDay = {
            date: currentDate,
            dateString: currentDate.toISOString().split('T')[0],
            dayOfMonth: currentDate.getDate(),
            dayOfWeek: (currentDate.getDay() + 6) % 7, // 0 = Mon, ..., 6 = Sun
            isCurrentMonth: currentMonth === month,
            isPrevMonth: currentMonth < month || (month === 0 && currentMonth === 11),
            isNextMonth: currentMonth > month || (month === 11 && currentMonth === 0),
        };

        currentWeek.push(dayObj);

        // Every 7 days, push the week row into 2D array and start a new week
        if (currentWeek.length === 7) {
            weeks.push(currentWeek);
            currentWeek = [];
        }
    }

    return weeks;
}